import './App.css';
import ChatBotFrame from './components/modal/modalcom';

import RoutesPaths from './components/pages/RoutesFile/RoutesPaths';

function App() {
  return (
    <div className="">
      <RoutesPaths />
      <ChatBotFrame />
    </div>
  );
}

export default App;